import PrintModal from './print-modal';

export default PrintModal;
